import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { environment } from './environment/environment'
import packageJson from '../package.json'
import Bugsnag from '@bugsnag/js'

export const enum Environment {
    Development = 'development',
    Test = 'test',
    Acceptance = 'acceptance',
    Production = 'production',
}

Bugsnag.start({
    apiKey: '4feb9c595a24f113cf1532d20e5a54cb',
    releaseStage: environment.stage,
    appVersion: packageJson.version,
    redactedKeys: [
        'code',
        'password',
    ],
    enabledReleaseStages: [
        Environment.Development,
        Environment.Test,
        Environment.Acceptance,
        Environment.Production,
    ],
})

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err))
